<template>
  <div class="questionnaire" ref="questionnaire">
    <div class="centent-mobile">
      <Header></Header>
      <div class="box-top">
        <div class="text-bold">{{ $t("aboutSurveyPage.thisWe") }}</div>
        <div class="text-encourage">{{ $t("aboutSurveyPage.share") }}</div>
        <div class="opinionworld" @click="skip('/helpFeedback?activeNames=1')">
          {{ $t("aboutSurveyPage.try") }}
        </div>
        <img
          class="arrowhead-down"
          @click="arrowheadDown"
          src="@/assets/img/arrowhead-down.png"
        />
      </div>
      <!-- <div class="mask"></div> -->
      <div class="pc">
        <div class="pc-right">
          <div class="weOpinions">{{ $t("aboutSurveyPage.what") }}</div>
          <p>{{ $t("aboutSurveyPage.unique") }}</p>
          <p>{{ $t("aboutSurveyPage.reason") }}</p>
          <p>
            {{ $t("aboutSurveyPage.platform") }}
          </p>
          <div class="learn-more" @click="skip('/helpFeedback?activeNames=1')">
            {{ $t("aboutSurveyPage.more") }}
          </div>
          <img class="circle" src="@/assets/img/circle.png" />
        </div>
        <img class="bg-centent" src="@/assets/img/bg-centent.jpg" />
      </div>
      <div class="pc exchange">
        <div class="pc-left">
          <div class="weOpinions ourSurvey">
            {{ $t("aboutSurveyPage.ourSurvey") }}
          </div>
          <p>
            {{ $t("aboutSurveyPage.ourHope") }}
          </p>
        </div>
        <img class="bg-bule" src="@/assets/img/bg-bule.png" />
      </div>

      <!-- 页脚 -->
      <Footer></Footer>
    </div>
  </div>
</template>
<script>
import Footer from "../../components/mycom/footer.vue";
import Header from "../../components/mycom/header.vue";
export default {
  components: { Footer, Header },
  data() {
    return {
      showSheet: false,
      showLangSheet: false,
      actions: [
        /*{ id: "1", name: "中文" },*/
        { id: "2", name: "English" },
      ],
    };
  },
  methods: {
    toHome() {
      this.$router.push({
        path: `/`,
      });
    },
    gourl() {
      this.$router.push({
        path: `register`,
      });
    },
    skip(url) {
      this.$router.push({
        path: url,
      });
    },
    openSheet() {
      this.showSheet = !this.showSheet;
    },
    onSelect(value) {
      if (value.id == "1") {
        this.$i18n.locale = "zh";
      } else {
        this.$i18n.locale = "en";
      }
      localStorage.setItem("lang", this.$i18n.locale);
      this.showSheet = false;
      this.showLangSheet = false;
    },

    handleJump(flag) {
      switch (flag) {
        case 1:
          this.showLangSheet = true;
          break;
        case 2:
          this.$router.push("/integralAward");
          break;
        case 3:
          this.$router.push("/aboutQuestionnaire");
          break;
        case 4:
          this.$router.push("/helpFeedback");
          // this.$router.push("/offenQuestion");
          break;
        default:
          break;
      }
    },
    // 点击下拉
    arrowheadDown() {
      this.$refs.questionnaire.scrollTop = 700;
      console.log(1234);
    },
  },
  mounted() {
    this.$refs.questionnaire.scrollTop = 0;
  },
  created() {
    // 判断是否是全屏显示
    console.log(1111, localStorage.getItem("questionnaireItem"));
    setTimeout(() => {
      if (
        localStorage.getItem("questionnaireItem") == 0 ||
        !localStorage.getItem("questionnaireItem")
      ) {
        localStorage.setItem("questionnaireItem", 1);
        //this.$router.go(0);
      }
    }, 100);
    //修改title
    document.title =
      "About Weopinions | Learn More About Us description: Learn more about Weopinions, why we conduct surveys and how your opinion affects the market. Share your opinion and earn rewards.";
  },
  beforeDestroy() {
    localStorage.setItem("questionnaireItem", 0);
  },
};
</script>
<style scoped>
.questionnaire {
  height: 100vh;
  overflow: auto;
}
.centent-mobile {
  width: 100%;
  min-height: 100vh;
  margin: 0 auto;
  background-color: #f8f8f7;
  position: relative;
}
.box-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
  height: 356px;
  padding-top: 112px;
  background-image: url("../../assets/img/bg-about.jpg");
  background-size: cover;
  background-position-x: 40%;
  color: #fff;
  margin-bottom: 33px;
}

.mask {
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  width: 100%;
  max-width: 768px;
  height: 468px;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9;
}

header {
  position: fixed;
  top: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #ffffff;
  z-index: 999;
  box-shadow: 0px 3px 6px 1px #c6c5c6;
}
.box-add {
  width: 85px;
  height: 60px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  line-height: 60px;
  background-color: #2e67ea;
  text-align: center;
}
.pinios {
  width: calc(100% - 95px);
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  opacity: 0.8;
}
.pinios > img {
  width: 192px;
  height: 48px;
  cursor: pointer;
}
.develop {
  width: 35px;
  height: 60px;
  background-color: #fff;
  opacity: 0.8;
  display: flex;
  align-items: center;
}
.develop > img {
  width: 35px;
  height: 35px;
  margin-right: 12px;
}
.text-bold {
  position: relative;
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  z-index: 99;
}
.text-encourage {
  position: relative;
  text-align: center;
  font-size: 16px;
  z-index: 99;
  margin-top: 32px;
}
.opinionworld {
  position: relative;
  width: 177px;
  height: 37px;
  line-height: 37px;
  text-align: center;
  background: #2e67ea;
  opacity: 1;
  z-index: 99;
  font-size: 12px;
  font-weight: bold;
  margin-top: 33px;
}
.arrowhead-down {
  position: relative;
  z-index: 99;
  width: 49px;
  height: 49px;
  margin-top: 28px;
  cursor: pointer;
}
.weOpinions {
  width: calc(100% - 16px);
  height: 29px;
  font-size: 26px;
  font-weight: bold;
  color: #232323;
  margin-left: 16px;
  margin-bottom: 10px;
}
p {
  width: calc(100% - 31px);
  font-size: 12px;
  font-weight: 400;
  line-height: 24px;
  color: #232323;
  margin-left: 16px;
}
.learn-more {
  width: 102px;
  font-size: 14px;
  font-weight: bold;
  color: #f5771a;
  float: right;
  margin-right: 15px;
  text-align: right;
  cursor: pointer;
}
.circle {
  width: 60px;
  height: 60px;
  margin-left: 15px;
  margin-top: 30px;
}
.bg-centent {
  width: 100%;
  margin-top: 24px;
  margin-bottom: 44px;
}
.bg-bule {
  width: calc(100% - 121px);
  margin-left: 63px;
  margin-top: 38px;
}
.box-bottom {
  width: 100%;
  min-height: 462px;
  padding-top: 38px;
  background: #2e67ea;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-top: 74px;
  margin-bottom: 10px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.box-bottom > .title {
  width: 100%;
  font-size: 26px;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: center;
}
.box-bottom > p {
  color: #fff;
  text-align: center;
}
.more {
  width: 98px;
  height: 31px;
  background: #ffffff;
  text-align: center;
  line-height: 31px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  color: #000;
  font-size: 14px;
  margin-top: 23px;
  margin-bottom: 30px;
}
.box-white {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 330px;
  height: 176px;
  background: #ffffff;
  border-radius: 18px 18px 18px 18px;
  opacity: 1;
  margin-top: 25px;
}
.box-white > p {
  text-align: center;
}
</style>
<style scoped>
@media only screen and (min-width: 768px) {
  .pc {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-content: center;
  }
  .exchange {
    flex-direction: row;
  }
  .pc .bg-centent {
    width: calc(50% - 20px);
    margin-left: 20px;
  }
  .pc .bg-bule {
    width: 55%;
    margin-right: 20px;
    margin-left: 0;
  }
  .pc .pc-right .weOpinions {
    margin-top: 40px;
  }
  .pc .pc-left .ourSurvey {
    margin-top: 100px;
    margin-left: 20px;
  }
}
</style>

</style>


// WEBPACK FOOTER //
// src/pages/aboutQuestionnaire/AboutQuestionnaire.vue